@if (tab) {
  @if (tab.url) {
    <a
      class="nk-tab-menu-item d-flex flex-row flex-md-column me-0 me-md-2"
      [class.active]="tab.active"
      [routerLink]="tab.url"
      [attr.data-cy]="'tab-' + tab.dataCy">
      <ng-container *ngTemplateOutlet="tabData"></ng-container>
    </a>
  } @else {
    <span
      class="nk-tab-menu-item me-0 me-md-2"
      [class.active]="tab.active"
      [attr.data-cy]="'tab-' + tab.dataCy"
      (click)="clickTab(tabIndex)">
      <ng-container *ngTemplateOutlet="tabData"></ng-container>
    </span>
  }
}

<ng-template #tabData>
  @if (tab && tab.data) {
    <div class="nk-tab-menu-item-icon me-2 me-md-0">
      @if (tab.data.faicon) {
        <i [ngClass]="'fa fa-' + tab.data.faicon"></i>
      }
    </div>
    <div class="nk-tab-menu-item-text">
      {{ tab.data.title | translate }}
      @if (tab.data.badgeEmphasis && tab.data.badgeText) {
        <span
          class="badge badge{{ tab.data.badgeEmphasis ? '-' + tab.data.badgeEmphasis : '' }} nk-tab-menu-item-badge">
          {{ tab.data.badgeText | translate }}
        </span>
      }
    </div>
  }
</ng-template>
